import { Component, Input, OnDestroy } from '@angular/core';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { LocalStorageService } from 'ngx-webstorage';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/core/service/app-config.service';
import { MessageSubject, MessengerService } from 'src/app/core/service/messenger.service';
import { sortBy } from 'lodash';
import { AuditService } from 'src/app/core/service/audit.service';
import { AuditChannelListService } from 'src/app/core/service/grid-data/grid-data-audit-channel.service';

@Component({
  selector: 'app-channel-audit-list',
  templateUrl: './channel-audit-list.component.html',
  styleUrl: './channel-audit-list.component.scss'
})
export class ChannelAuditListComponent implements OnDestroy
{
  public pageSizes = [5, 10, 25, 50, 100];
  public currentChannelId: number;
  public currentEnableAdvanced: boolean;
  public revisionTypes: Array<{ text: string; value: number }>;
  public auditTypes: Array<{ text: string; value: number }>;
  public changesOnly: boolean;

  public state: State = {
    skip: 0,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      { field: 'revisionId', dir: 'desc' }
    ]
  };

  public gridView: GridDataResult;
  public gridData: any = {};
  public total: number;

  private listSubscription: Subscription;

  /**
   * Constructor
   */
  constructor(
    private appConfigService: AppConfigService,
    private auditChannelListService: AuditChannelListService,
    private messengerService: MessengerService,
    private storageService: LocalStorageService,
    private auditService: AuditService)
  {
    if (this.storageService.retrieve('changes-only-audit-channels') === null || this.storageService.retrieve('changes-only-audit-channels') === undefined)
    {
      this.storageService.store('changes-only-audit-channels', true);
    }
    this.changesOnly = this.storageService.retrieve('changes-only-audit-channels');
  }

  public get loading(): boolean
  {
    return this.auditChannelListService.loading;
  }

  @Input() public set channelId(channelId: number)
  {
    if (channelId !== undefined)
    {
      this.currentChannelId = channelId;
      this.state.skip = 0;
      this.revisionTypes = sortBy(this.auditService.revisionTypes, ['text']);
      this.auditTypes = sortBy(this.auditChannelListService.auditTypes, ['text']);
      this.loadAuditChannel();
    }
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public dataStateChange(state: DataStateChangeEvent): void
  {
    this.state = state;
    this.auditChannelListService.queryByState(state);
  }

  public ngOnDestroy(): void
  {
    if (this.listSubscription !== undefined) { this.listSubscription.unsubscribe(); }
  }

  public onChangesOnlyChange(newValue: boolean): void
  {
    this.changesOnly = newValue;
    this.storageService.store('changes-only-audit-channels', this.changesOnly);
    this.messengerService.sendMessage(new MessageSubject('refreshAuditChannelDetails'));
  }

  private loadAuditChannel(): void
  {
    this.state.take = this.appConfigService.getConfig().pageSize;
    this.state.filter.filters.push({ field: 'channelId', operator: 'eq', value: this.currentChannelId });
    this.listSubscription = this.auditChannelListService.subscribe({
      next: (value: any) =>
      {
        if (value !== null)
        {
          value.data.forEach(d =>
          {
            d.timestampUTC = new Date(d.timestampUTC);
            d.revisionTypeText = this.auditService.getRevisionTypeText(d.revisionType);
            d.auditTypeText = this.auditChannelListService.getAuditTypeText(d.auditType);
          });
          this.gridView = {
            data: (value) ? this.gridData = value.data : this.gridData = [],
            total: (value) ? this.total = value.total : this.total = 0
          };
        }
      }
    });
    this.auditChannelListService.queryByState(this.state);
  }
}
